import React, { ChangeEvent } from 'react';

interface Props {
  formState: {availability: string, sold_through: string, sold_through_additional_info: string},
  onChange: (value: ChangeEvent<HTMLTextAreaElement>) => void,
}

const ADDITIONAL_INFO_TEXT_AREA_LIMIT = 255;
const ADDITIONAL_INFO_SHOW_FOR = ['other_site', 'other'];

const AdditionalInfoTextArea: React.FC<Props> = ({ formState, onChange }) => {
  if (!ADDITIONAL_INFO_SHOW_FOR.includes(formState?.sold_through)) {
    return null;
  }

  return (
    <div>
      <div
        className="my-1"
      >
        {formState?.sold_through === 'other_site' ? 'What other website?' : 'Please provide more details'}
      </div>
      <div className="position-relative">
        <div className="text-area-limit">{`${formState?.sold_through_additional_info?.length ?? 0}/${ADDITIONAL_INFO_TEXT_AREA_LIMIT}`}</div>
        <textarea
          className="w-100 text-area-ads-actions"
          placeholder="Type here"
          maxLength={ADDITIONAL_INFO_TEXT_AREA_LIMIT}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default AdditionalInfoTextArea;
